import { apiClient } from './apiClient';
import { LLMConfig, CreateLLMConfigRequest, UpdateLLMConfigRequest } from '../types';

const BASE_URL = '/admin/llm-configs';
const TENANT_ACTIVE_URL = '/tenant/me/llm-configs/domains';

export const llmConfigService = {
  async list(domain?: string): Promise<LLMConfig[]> {
    const params = new URLSearchParams();
    if (domain) params.append('domain', domain);

    const url = params.toString() ? `${BASE_URL}?${params}` : BASE_URL;
    const response = await apiClient.get<LLMConfig[]>(url);
    return response.data;
  },

  async get(id: string): Promise<LLMConfig> {
    const response = await apiClient.get<LLMConfig>(`${BASE_URL}/${id}`);
    return response.data;
  },

  async getActive(domain: string): Promise<LLMConfig> {
    const response = await apiClient.get<LLMConfig>(`${TENANT_ACTIVE_URL}/${domain}/active`);
    return response.data;
  },

  async create(data: CreateLLMConfigRequest): Promise<LLMConfig> {
    const response = await apiClient.post<LLMConfig>(BASE_URL, data);
    return response.data;
  },

  async update(id: string, data: UpdateLLMConfigRequest): Promise<LLMConfig> {
    const response = await apiClient.patch<LLMConfig>(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE_URL}/${id}`);
  },

  async activate(id: string): Promise<LLMConfig> {
    const response = await apiClient.post<LLMConfig>(`${BASE_URL}/${id}/activate`);
    return response.data;
  },
};
